export default __webpack_public_path__ + "static/media/chapter3.502a4f2c.jpg";